import { lazy } from 'react'
import { withUserChallengesProvider } from '../../hooks/withUserChallengesProvider'
import PastChallenges from './PastChallenges'

export const LazyPastChallenges = lazy(() => import('./PastChallenges'))
export const PastChallengeWithUserChallengesProvider =
    withUserChallengesProvider(LazyPastChallenges, false)

export default PastChallenges
